import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCabinDetails } from "../redux/cabin-upgrade";
import StateRoomCard from "../components/UpgradeStateroom/StateRoomCard";
import Loader from "../components/Loader";
import { getSuppCartAddCondition } from "../utils/helperFunctions/supplements";
import { StateroomsMap } from "../utils/helperFunctions/Stateroom";
import { getAllGuestCabins } from "../utils/helperFunctions/helperFunctions";

const UpgradeStateroom = ({ bookingDetails }) => {
  let { booking_id } = bookingDetails;
  let { room_id } = bookingDetails.room_with_guest_count[0];
  const [categoryTabs, setCategoryTabs] = useState([]);
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState("All");
  const { guest_count } = getSuppCartAddCondition(bookingDetails);
  const [guest_count_per_cabin, setGuestCountPerCabin] = useState(0);
  const [cabinsToDisplay, setCabinsToDisplay] = useState([]);
  const allCabinDetails = useSelector(
    (state) => state.allCabinDetails.cabin_details
  );
  const [availableCategories, setAvailableCategories] = useState([]);
  const isLoading = useSelector((state) => state.allCabinDetails.isLoading);

  useEffect(() => {
    const category_tabs = () => {
      const uniqueCategoryTitles = [
        "All",
        "Interior",
        "Ocean View",
        "Balcony",
        "Suite",
      ];
      return uniqueCategoryTitles;
    };
    setCategoryTabs(category_tabs);
  }, [allCabinDetails]);

  const [selectedCabin, setSelectedCabin] = useState("");

  useEffect(() => {
    if (room_id !== "" && booking_id !== "")
      dispatch(
        getCabinDetails({
          room_id: selectedCabin.split("-")[0] || room_id,
          booking_id: booking_id,
        })
      );
    // eslint-disable-next-line
  }, [selectedCabin, booking_id, room_id]);

  const availableGuestCabins = getAllGuestCabins(
    allCabinDetails,
    bookingDetails
  );

  useEffect(() => {
    if (availableGuestCabins.length > 0 && !selectedCabin) {
      setSelectedCabin(
        availableGuestCabins[0].room_id +
          "-" +
          availableGuestCabins[0].category_name
      );
    }
  }, [availableGuestCabins, selectedCabin]);

  useEffect(() => {
    if (selectedCabin && bookingDetails)
      setGuestCountPerCabin(
        bookingDetails?.room_with_guest_count?.filter(
          (room) => room.room_id === +selectedCabin.split("-")[0]
        )[0]?.guest_count
      );
  }, [selectedCabin, bookingDetails, guest_count]);

  useEffect(() => {
    if (guest_count_per_cabin && allCabinDetails.length > 0) {
      let cabinToDis = allCabinDetails.filter((stateroom) => {
        if (
          stateroom.occupancy >= guest_count_per_cabin &&
          stateroom.diff_price > 0 &&
          stateroom.available_room_count > 0 &&
          StateroomsMap[stateroom?.category_name]?.priority >
            StateroomsMap[
              selectedCabin?.substring(selectedCabin.indexOf("-") + 1).trim()
            ]?.priority
        )
          return true;
        else return false;
      });

      // To remove duplicates and select the cabin with the least occupancy but greater than the guest count.
      const uniqueCabinMap = new Map();
      cabinToDis.forEach((stateroom) => {
        if (
          !uniqueCabinMap.has(stateroom.category_name) ||
          (uniqueCabinMap.get(stateroom.category_name).occupancy >
            guest_count_per_cabin &&
            stateroom.occupancy <
              uniqueCabinMap.get(stateroom.category_name).occupancy)
        ) {
          uniqueCabinMap.set(stateroom.category_name, stateroom);
        }
      });
      cabinToDis = Array.from(uniqueCabinMap.values());

      cabinToDis = cabinToDis
        .sort(
          (a, b) =>
            StateroomsMap[b.category_name]?.priority -
            StateroomsMap[a.category_name]?.priority
        )
        .filter((stateroom) => {
          if (currentTab === "All") {
            setAvailableCategories(
              cabinToDis.map((cabin) => cabin.category_name)
            );
            return true;
          } else return stateroom?.category_name.includes(currentTab);
        });

      setCabinsToDisplay(cabinToDis);
    }
  }, [allCabinDetails, selectedCabin, currentTab, guest_count_per_cabin]);

  return (
    <div>
      <div className="md:w-3/4 mx-auto p-4 md:p-8">
        <div className="flex flex-col md:flex-row gap-5 py-4 items-center justify-center">
          <div className="text-xl text-center uppercase text-mv-darkblue  font-bold">
            Select a cabin to upgrade
          </div>
          <select
            value={selectedCabin}
            onChange={(e) => setSelectedCabin(e.target.value)}
            className="border-2 px-4 flex items-center border-mv-darkblue rounded-lg p-2"
          >
            {availableGuestCabins.map((cabin) => (
              <option
                key={cabin.room_id + "-" + cabin.category_name}
                value={cabin.room_id + "-" + cabin.category_name}
              >
                {cabin.room_no + " " + cabin.category_name}
              </option>
            ))}
          </select>
        </div>
        <hr />
        <div>
          <h1 className="text-2xl text-center uppercase text-mv-darkblue  font-bold">
            Upgrade your stateroom
          </h1>
        </div>
        {cabinsToDisplay.length > 0 ? (
          <>
            <div className="flex justify-around text-xl py-4 mt-4 px-5 md:px-10 font-semibold">
              {categoryTabs?.map((category) => {
                if (
                  availableCategories.some((stateroom) =>
                    stateroom.includes(category)
                  ) ||
                  category === "All"
                )
                  return (
                    <div
                      key={category}
                      className={`cursor-pointer category-head ${
                        currentTab === category
                          ? "underline font-bold text-mv-darkblue"
                          : "text-[#6699C2]"
                      }`}
                      onClick={() => setCurrentTab(category)}
                    >
                      {category}
                    </div>
                  );
                else return null;
              })}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 mt-4 gap-5">
              {cabinsToDisplay.map((stateroom) => (
                <StateRoomCard
                  guest_count_per_cabin={guest_count_per_cabin}
                  key={stateroom.category_id}
                  selectedCabin={selectedCabin}
                  stateroom={stateroom}
                />
              ))}
            </div>
          </>
        ) : (
          !isLoading && (
            <div className="text-center text-xl py-5 text-mv-darkblue font-semibold">
              There are no stateroom upgrades available for your sailing at this
              moment.
            </div>
          )
        )}
      </div>
      <Loader isLoading={isLoading} />
    </div>
  );
};

export default UpgradeStateroom;
